/**
 * Where to send someone to sign in.
 *
 * The Myela dashboard is the only login: it mints the shared `myela-session`
 * cookie that this portal reads. `/login/agent-portal` is its product-login
 * route — it signs the user in, then bounces them back here, so no raw URL
 * ever travels in a query string.
 *
 * `?to=` carries the path they were trying to reach, percent-encoded so a deep
 * link's own query survives the round trip. Only a same-app relative path is
 * sent: "//host" is protocol-relative and URL treats "\" as "/", so both are
 * dropped rather than handed to the dashboard as a redirect target.
 */
const DEFAULT_DASHBOARD_URL = "http://localhost:3003";

export function dashboardUrl(): string {
  const configured = import.meta.env.VITE_DASHBOARD_URL as string | undefined;
  return (configured || DEFAULT_DASHBOARD_URL).replace(/\/+$/, "");
}

export function dashboardLoginUrl(returnTo?: string): string {
  const path = safeReturnPath(returnTo ?? currentPath());
  const query = path ? `?to=${encodeURIComponent(path)}` : "";
  return `${dashboardUrl()}/login/agent-portal${query}`;
}

function currentPath(): string {
  if (typeof window === "undefined") return "";
  const { pathname, search } = window.location;
  // Never ask to come back to the signed-out page itself.
  return pathname.startsWith("/login") ? "" : `${pathname}${search}`;
}

export function safeReturnPath(path: string): string {
  if (!path.startsWith("/")) return "";
  if (path[1] === "/" || path[1] === "\\") return "";
  return path;
}
